import APIClient from '../../services/APIClient';
import { filterPlaceHolder, makeApiCall } from '../../services/ApiService';

export default {

    getScriptResults: (params: any) => makeApiCall({
        startCallMessage: 'API: Script Results Data',
        successMessage: 'API: Successfully Fetched Script Results Data',
        failureMessage: 'API: Fetching Script Results Failed',
        params,
        url: '/admin/script-results',
        method: APIClient.get,
        data: null,
        config: null,
        shouldShowNotifications: true,
        extractPath: (data) => data.scriptResults,
    }),

    deleteScriptResults: (data: any) => makeApiCall({
        startCallMessage: 'API: Deleting Script Results',
        successMessage: 'API: Deleting Script Results Success',
        failureMessage: 'API: Deleting Script Results Failed',
        data,
        url: '/admin/script-results/delete',
        method: APIClient.post,
        config: null,
        extractPath: (data) => data,
    }),

    editScriptResults: (data: any) => makeApiCall({
        startCallMessage: 'API: Editing Script Results',
        successMessage: 'API: Editing Script Results Success',
        failureMessage: 'API: Editing Script Results Failed',
        data,
        url: '/admin/script-results' + (data._id ? `/${data._id}` : ''),
        method: APIClient.put,
        config: null,
        extractPath: (data) => data,
    })
}